// Tipos compartidos para el layout regional
import type { Locale } from "@/i18n/config";

/**
 * Texto de los portales regionales. El portugués es opcional: estos sitios
 * todavía se publican en es/en y `pickLocalized` cae al español si falta.
 */
export type LocalizedText = Record<"es" | "en", string> &
  Partial<Record<Locale, string>>;

export function pickLocalized(text: LocalizedText, locale: Locale): string {
  return text[locale] ?? text.es;
}

export interface NavLink {
  label: LocalizedText;
  href: string;
  icon?: React.ReactNode;
}

export interface RegionalAirportConfig {
  code: string;
  name: LocalizedText;
  logo?: string;
  basePath: string; // e.g., "/mppa", "/david", "/riohato"
  navLinks: NavLink[];
  contact: {
    phone: string;
    email?: string;
    address: LocalizedText;
  };
  socialLinks?: {
    facebook?: string;
    instagram?: string;
    twitter?: string;
  };
}
